import { http, httpgst } from '../../main'
import { store } from '../../store'

const actions = {
  getRepresentatives ({commit, dispatch}, payload) {
    let url = 'api/cashier-reservation-by-company'
    
    let options = { emulateJSON: false, headers: { 'Content-Type': 'application/json' } }

    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token

    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGetRepresentatives', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  deleteRepresentatives ({ commit, dispatch }, payload) {
    let url = 'api/cashier/' + payload.event.item.id
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.delete(url, {}, {})
      .then(
        response => {
          commit('representativesDelete', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  async downloadReport({ commit }, { event }) {
    try {
      const url = 'api/cashier-reservation/report'

      const options = { emulateJSON: false, headers: { 'Content-Type': `application/xlsx` } }

      const params = { responseType: 'blob' }
      
      httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token

      const response = await httpgst.get(url, params, options)

      const reportBinary = response.data

      event.context.forceFileDownload(reportBinary, `report-representatives.xlsx`)
      
    } catch (error) {
      event.context.showNotification(error, 'error')
    } finally {
      event.context.loadingExcelReport = false
    }
  }
}

const mutations = {
  onGetRepresentatives (state, payload) {
    let representatives = payload.response.data.data
    
    const result = []

    representatives.forEach(rep => {
      rep.users.forEach(user => {
        result.push({ ...rep, representative: user })
      })
    })
    
    payload.event.context.representatives = result
    payload.event.context.loadingItems = false
  },
  representativesDelete (state, payload) {
    let representatives = payload.event.context.representativess
    representatives.splice(payload.event.index, 1)
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.closeDelete()
    payload.event.context.loading = false
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }

    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
  }
}

export default {
  namespaced: true,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/representatives.js